import { useFrame } from "@react-three/fiber"
import SinglePlot from "./SinglePlot"

import useVars from './Stores/useVars.jsx'
import { useEffect, useRef, useState } from 'react'
// import useMoney from "./Stores/useMoney.jsx"

export default function CityLayout()
{
    /**
     * GRID
     * 0 is blank space, 1 is addButton
     * 2,3,4 are nature
     * 5,6,7 are industrial
     * 8,9,10 are residential
     * 11,12,13 are entertainment
     * 14,15,16 are utility
     */
    let grid = []
    for(let i = 0; i < 7; i++)
    {
        const column = [0,0,0,0,0,0,0]
        grid.push(column)
    }

    /**
     * These are plot specific variables that are needed
     */

    //STARTING POSITION
    grid[3][3] = 2

    const [gridState, setGridState] = useState(grid)

    /**
     * TO-DO: REALLY GOTTA LEARN HOW TO MAP THIS GRIDSTATE IN CHANGEGRIDSTATE
     * SO WE DON'T HAVE TO CONSOLE PRINT IT? MIGHT ALSO FIX THE DOUBLE RENDERING
     */

    const changeGridState = () => {
        setGridState(grid)
    }

    let plotCoords = [3,3]
    let purchasedPlot = Date.now()
    let boardStartTime = 0
    let localPlots = 1
    const varsState = useVars()

    function PurchasePlot()
    {
        localPlots++
        grid[plotCoords[0]][plotCoords[1]] = purchasedPlot + 2
        varsState.setPopulation(20)
        CalculateRevenue()
    }

    
    
    let loopInterval
    useEffect(() => {
        const unsubscribeCoords = useVars.subscribe(
            (state) => state.plotCoords,
            (value) =>
            {
                plotCoords = value
            }
        )
        const unsubscribePlot = useVars.subscribe(
            (state) => state.purchasedPlot,
            (value) =>
            {
                purchasedPlot = value
            }
        )
        const unsubscribePhase = useVars.subscribe(
            (state) => state.phase,
            (value) =>
            {
                if(value == 'scrolling' && boardStartTime != 0)
                    PurchasePlot()
                if(value == 'gameOver')
                    clearInterval(loopInterval)
            }
        )
        const unsubscribeStartTime = useVars.subscribe(
            (state) => state.startTime,
            (value) =>
            {
                // console.log("Game Starting" + value)
                boardStartTime = value
                loopInterval = setInterval(GenerateRevenue, 3000)
            }
        )

        return () =>
        {
            unsubscribeCoords()
            unsubscribePlot()
            unsubscribePhase()
            unsubscribeStartTime()
        }
    }, [])

    /**
     * HERE IS OUR LOOP
     * CONTAINS THE INTERVAL (DEFAULT: 3s)
     */
    // const moneyState = useMoney()
    function GenerateRevenue()
    {
        varsState.addMoney(localSalary)
        varsState.addVictoryPoints(localSalary)
        // varsState.victoryPoints += (localSalary)
        // console.log(varsState.victoryPoints)
    }


    /**
     * Calculates Revenue
     * And Population
     */
    let localSalary = 5
    let localPop = 0

    function CalculatePopulation()
    {
        localPop = 0
        for(let x = 0; x < grid[0].length; x++)
        {
            for(let y = 0; y < grid[0].length; y++)
            {
                // sum += gridState[x][y]
                const currentPlot = gridState[x][y]
                if(currentPlot == 0 || currentPlot == 1)
                {
                    //Space is empty
                }
                else if(currentPlot == 8) //POPULATION CALCULATORS FIRST
                {
                    CalculateApartmentPopulation(x,y)
                }
                else if(currentPlot == 9)
                {
                    CalculateTownhousePopulation(x,y)
                }
                else if(currentPlot == 10)
                {
                    CalculateHousesPopulation(x,y)
                }
            }
        }
    }
    function CalculateRevenue()
    {
        CalculatePopulation()
        let sum = 0
        for(let x = 0; x < grid[0].length; x++)
        {
            for(let y = 0; y < grid[0].length; y++)
            {
                // sum += gridState[x][y]
                const currentPlot = gridState[x][y]
                if(currentPlot == 0 || currentPlot == 1)
                {
                    //Space is empty
                }
                else if(currentPlot == 2)
                {
                    sum += GenerateForestRevenue(x,y)
                }
                else if(currentPlot == 3)
                {
                    sum += GeneratePondRevenue(x,y)
                }
                else if(currentPlot == 4)
                {
                    sum += GenerateGardenRevenue(x,y)
                }
                else if(currentPlot == 5)
                {
                    sum += GenerateFactoryRevenue(x,y)
                }
                else if(currentPlot == 6)
                {
                    sum += GenerateLumberyardRevenue(x,y)
                }
                else if(currentPlot == 7)
                {
                    sum += GeneratePowerplantRevenue(x,y)
                }
                else if(currentPlot == 8)
                {
                    sum += GenerateApartmentsRevenue(x,y)
                }
                else if(currentPlot == 9)
                {
                    sum += GenerateTownhouseRevenue(x,y)
                }
                else if(currentPlot == 10)
                {
                    sum += GenerateHousesRevenue(x,y)
                }
                else if(currentPlot == 11)
                {
                    sum += GenerateTheaterRevenue(x,y)
                }
                else if(currentPlot == 12)
                {
                    sum += GenerateRestaurantRevenue(x,y)
                }
                else if(currentPlot == 13)
                {
                    sum += GenerateMuseumRevenue(x,y)
                }
            }
        }
        
        varsState.setSalary(sum)
        localSalary = sum
        // console.log(localPop)
        varsState.setPopulation(localPop)
        // console.log(varsState.population)
    }

    function GenerateForestRevenue(x,y)
    {
        return 5
    }

    function GeneratePondRevenue(x,y)
    {
        let sum = 3
        if(x > 0 && gridState[x-1][y] < 2)
            sum+=2
        if(x < 6 && gridState[x+1][y] < 2)
            sum+=2
        if(y < 6 && gridState[x][y+1] < 2)
            sum+=2
        if(y > 0 && gridState[x][y-1] < 2)
            sum+=2
        return sum
    }

    function GenerateGardenRevenue(x,y)
    {
        return 5
    }

    function GenerateFactoryRevenue(x,y)
    {
        return localPlots > localPop ? 12 : 2
    }

    function GenerateLumberyardRevenue(x,y)
    {
        let sum = 2
        if(x > 0 && gridState[x-1][y] == 2)
            sum += 12
        if(x < 6 && gridState[x+1][y] == 2)
            sum += 12
        if(y < 6 && gridState[x][y+1] == 2)
            sum += 12
        if(y > 0 && gridState[x][y-1] == 2)
            sum += 12
        return sum
    }

    function GeneratePowerplantRevenue(x,y)
    {
        let sum = 2
        if(x > 0 && gridState[x-1][y] >= 5 && gridState[x-1][y] <= 7)
            sum+=6
        if(x < 6 && gridState[x+1][y] >= 5 && gridState[x+1][y] <= 7)
            sum+=6
        if(y < 6 && gridState[x][y+1] >= 5 && gridState[x][y+1] <= 7)
            sum+=6
        if(y > 0 && gridState[x][y-1] >= 5 && gridState[x][y-1] <= 7)
            sum+=6
        return sum
    }

    function GenerateApartmentsRevenue(x,y)
    {
        return 1
    }

    function GenerateTownhouseRevenue(x,y)
    {
        return 1
    }

    function GenerateHousesRevenue(x,y)
    {
        return 1
    }

    function GenerateTheaterRevenue(x,y)
    {
        let sum = 1
        if(x > 0 && gridState[x-1][y] >= 8 && gridState[x-1][y] <= 10)
            sum+=5
        if(x < 6 && gridState[x+1][y] >= 8 && gridState[x+1][y] <= 10)
            sum+=5
        if(y < 6 && gridState[x][y+1] >= 8 && gridState[x][y+1] <= 10)
            sum+=5
        if(y > 0 && gridState[x][y-1] >= 8 && gridState[x][y-1] <= 10)
            sum+=5
        return sum
    }

    function GenerateRestaurantRevenue(x,y)
    {
        return (localPop / 5)
    }

    function GenerateMuseumRevenue(x,y)
    {
        return Math.trunc(localPlots / 2)
    }

    function CalculateApartmentPopulation(x,y)
    {
        let sum = 15
        if(x > 0 && gridState[x-1][y] >= 5 && gridState[x-1][y] <= 7)
            sum-=5
        if(x < 6 && gridState[x+1][y] >= 5 && gridState[x+1][y] <= 7)
            sum-=5
        if(y < 6 && gridState[x][y+1] >= 5 && gridState[x][y+1] <= 7)
            sum-=5
        if(y > 0 && gridState[x][y-1] >= 5 && gridState[x][y-1] <= 7)
            sum-=5
        localPop += sum
    }

    function CalculateTownhousePopulation(x,y)
    {
        localPop += 10
    }

    function CalculateHousesPopulation(x,y)
    {
        let sum = 5
        if(x > 0 && gridState[x-1][y] >= 8 && gridState[x-1][y] <= 10)
            sum+=5
        if(x < 6 && gridState[x+1][y] >= 8 && gridState[x+1][y] <= 10)
            sum+=5
        if(y < 6 && gridState[x][y+1] >= 8 && gridState[x][y+1] <= 10)
            sum+=5
        if(y > 0 && gridState[x][y-1] >= 8 && gridState[x][y-1] <= 10)
            sum+=5
        localPop += sum
    }
    

    let plotSpacing = 2.5
    return <>

        {/* Row 1 */}
        <SinglePlot position={[-3*plotSpacing,0,-3*plotSpacing]} plotId={0}/>
        <SinglePlot position={[-2*plotSpacing,0,-3*plotSpacing]} plotId={0}/>
        <SinglePlot position={[-plotSpacing,0,-3*plotSpacing]} plotId={0}/>
        <SinglePlot position={[0,0,-3*plotSpacing]} plotId={0}/>
        <SinglePlot position={[plotSpacing,0,-3*plotSpacing]} plotId={0}/>
        <SinglePlot position={[2*plotSpacing,0,-3*plotSpacing]} plotId={0}/>
        <SinglePlot position={[3*plotSpacing,0,-3*plotSpacing]} plotId={0}/>

        {/* Row 2 */}
        <SinglePlot position={[-3*plotSpacing,0,-2*plotSpacing]} plotId={0}/>
        <SinglePlot position={[-2*plotSpacing,0,-2*plotSpacing]} plotId={0}/>
        <SinglePlot position={[-plotSpacing,0,-2*plotSpacing]} plotId={0}/>
        <SinglePlot position={[0,0,-2*plotSpacing]} plotId={0}/>
        <SinglePlot position={[plotSpacing,0,-2*plotSpacing]} plotId={0}/>
        <SinglePlot position={[2*plotSpacing,0,-2*plotSpacing]} plotId={0}/>
        <SinglePlot position={[3*plotSpacing,0,-2*plotSpacing]} plotId={0}/>

        {/* Row 3 */}
        <SinglePlot position={[-3*plotSpacing,0,-plotSpacing]} plotId={0}/>
        <SinglePlot position={[-2*plotSpacing,0,-plotSpacing]} plotId={0}/>
        <SinglePlot position={[-plotSpacing,0,-plotSpacing]} plotId={0}/>
        <SinglePlot position={[0,0,-plotSpacing]} plotId={1}/>
        <SinglePlot position={[plotSpacing,0,-plotSpacing]} plotId={0}/>
        <SinglePlot position={[2*plotSpacing,0,-plotSpacing]} plotId={0}/>
        <SinglePlot position={[3*plotSpacing,0,-plotSpacing]} plotId={0}/>

        {/* Row 4 */}
        <SinglePlot position={[-3*plotSpacing,0,0]} plotId={0}/>
        <SinglePlot position={[-2*plotSpacing,0,0]} plotId={0}/>
        <SinglePlot position={[-plotSpacing,0,0]} plotId={1}/>
        <SinglePlot position={[0,0,0]} plotId={2}/>
        <SinglePlot position={[plotSpacing,0,0]} plotId={1}/>
        <SinglePlot position={[2*plotSpacing,0,0]} plotId={0}/>
        <SinglePlot position={[3*plotSpacing,0,0]} plotId={0}/>

        {/* Row 5 */}
        <SinglePlot position={[-3*plotSpacing,0,plotSpacing]} plotId={0}/>
        <SinglePlot position={[-2*plotSpacing,0,plotSpacing]} plotId={0}/>
        <SinglePlot position={[-plotSpacing,0,plotSpacing]} plotId={0}/>
        <SinglePlot position={[0,0,plotSpacing]} plotId={1}/>
        <SinglePlot position={[plotSpacing,0,plotSpacing]} plotId={0}/>
        <SinglePlot position={[2*plotSpacing,0,plotSpacing]} plotId={0}/>
        <SinglePlot position={[3*plotSpacing,0,plotSpacing]} plotId={0}/>

        {/* Row 6 */}
        <SinglePlot position={[-3*plotSpacing,0,2*plotSpacing]} plotId={0}/>
        <SinglePlot position={[-2*plotSpacing,0,2*plotSpacing]} plotId={0}/>
        <SinglePlot position={[-plotSpacing,0,2*plotSpacing]} plotId={0}/>
        <SinglePlot position={[0,0,2*plotSpacing]} plotId={0}/>
        <SinglePlot position={[plotSpacing,0,2*plotSpacing]} plotId={0}/>
        <SinglePlot position={[2*plotSpacing,0,2*plotSpacing]} plotId={0}/>
        <SinglePlot position={[3*plotSpacing,0,2*plotSpacing]} plotId={0}/>

        {/* Row 7 */}
        <SinglePlot position={[-3*plotSpacing,0,3*plotSpacing]} plotId={0}/>
        <SinglePlot position={[-2*plotSpacing,0,3*plotSpacing]} plotId={0}/>
        <SinglePlot position={[-plotSpacing,0,3*plotSpacing]} plotId={0}/>
        <SinglePlot position={[0,0,3*plotSpacing]} plotId={0}/>
        <SinglePlot position={[plotSpacing,0,3*plotSpacing]} plotId={0}/>
        <SinglePlot position={[2*plotSpacing,0,3*plotSpacing]} plotId={0}/>
        <SinglePlot position={[3*plotSpacing,0,3*plotSpacing]} plotId={0}/>

    </>
}